import { createStore } from "redux";
import { rootred } from "../Redux/Reducer/index";

export const store = createStore(rootred);